import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FormattedCurrency } from '../../../components/formatted-currency';

import { LabeledRow } from '../../../fulfillment-planner/labeled-row';
import { messages } from '../../../fulfillment-planner/labeled-row/messages';
import { CurrencyPropType } from '../../../prop-types/currency';

import style from './style.module.css';

const renderRateAmount = (totalCost) => {
  if (totalCost) {
    return <FormattedCurrency currencyCode={totalCost.code} value={totalCost.value} />;
  }
  return <span>- -</span>;
};

export const TotalCost = ({ totalCost, asStandardRow = false }) => {
  if (asStandardRow) {
    return (
      <LabeledRow className={style.row} label={<FormattedMessage {...messages.totalCost} />} labelClassName={style.label}>
        <span className={style.info}>{renderRateAmount(totalCost)}</span>
      </LabeledRow>
    );
  }
  return (
    <div className={style.rate}>
      <div>
        <FormattedMessage
          {...messages.formattedTotalCost}
          values={{
            formattedTotalCost: renderRateAmount(totalCost),
          }}
        />
      </div>
    </div>
  );
};

TotalCost.propTypes = {
  totalCost: CurrencyPropType,
  asStandardRow: PropTypes.bool,
};
